import baseApi from './base_api.js'

export function randomDigest() {
  return baseApi.post('/randomDigest')
}

export function sameBookDigest(options) {
  return baseApi.post('/sameBookDigest', { ...options })
}

export function sameAuthorDigest(options) {
  return baseApi.post('/sameAuthorDigest', { ...options })
}

export function sameDateDigest(options) {
  return baseApi.post('/sameDateDigest', { ...options })
}